import React, { useEffect, useState } from 'react';
 import { Link, useNavigate } from 'react-router-dom'; 
 import logo from '../assets/logo.png';
  import folder1 from '../assets/folder1.jpeg';
 import { toast } from 'react-toastify';
 import './Sidebar.css';
 import axios from '../axios';

const Sidebar = () => {
  const [folders, setFolders] = useState([]);

   const isLoggedIn = localStorage.getItem('token');

   const fetchFolders = async () => {
    try {
      const response = await axios.get('/folders');
      setFolders(response.data);
    } catch (err) {
      toast.error('Failed to load folders');
    }
  };

  useEffect(() => {
    fetchFolders();
  }, []);

  const navigate = useNavigate();

   const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className='sidebar-left'> 
    <div className="bg-light border-end  sidebar-in" style={{ width: '300px', height: '100vh', overflowY: 'auto' }}>
      <div className="p-3">
        <div class='logo-wrap'> <img src={logo}/></div>
        {isLoggedIn && (
        <ul className="list-unstyled">

          <li className="mb-2">
             <Link to="https://dhafirdc.com"  target='_blank'>Home</Link>
              
            </li> 
            <li className="mb-2">
             <Link to={"/folders"} >Main Folders</Link>
              
            </li> 
           { /***folders.map((folder, index) => (
         
            <li className="mb-2">
              <img src={folder1}  className='side-folder'/>
             <Link to={"/folders/"+folder.id} >{folder.name}</Link>
              
            </li>  
           )) **/}
          <li className="mb-2">
             <Link to={ "/change-password"} >Change Password</Link>
              
            </li>
          <li className="mb-2">
             <button onClick={logout} >Logout</button>
              
            </li>
          
        </ul>
        )}
      </div>
    </div>
    </div>
  );
};

export default Sidebar;
